import {SampleFilter, SampleFilterType} from 'notebook/sample-propagation/SampleFilter';

/**
 * Centralized file for the strings which describe samples for propagation.
 */

export interface SampleDescriptor {
  singular: string;
  plural: string;
  title: string;
}

export const EMPTY_SAMPLE_DESCRIPTOR: SampleDescriptor = {
  singular: '',
  plural: '',
  title: '',
};

const sampleFilterTexts: Record<SampleFilterType, SampleDescriptor> = {
  [SampleFilterType.BATCH]: {singular: 'batch', plural: 'batches', title: 'Batch'},
  [SampleFilterType.BIOENTITY]: {singular: 'entity', plural: 'entities', title: 'Entity'},
  [SampleFilterType.BOOLEAN]: {singular: 'boolean', plural: 'booleans', title: 'Boolean'},
  [SampleFilterType.BOX]: {singular: 'box', plural: 'boxes', title: 'Box'},
  [SampleFilterType.CONTAINER]: {singular: 'container', plural: 'containers', title: 'Container'},
  [SampleFilterType.FLOAT]: {singular: 'float', plural: 'floats', title: 'Float'},
  [SampleFilterType.INTEGER]: {singular: 'integer', plural: 'integers', title: 'Integer'},
  [SampleFilterType.PLATE]: {singular: 'plate', plural: 'plates', title: 'Plate'},
  [SampleFilterType.STORABLE]: {singular: 'storable', plural: 'storables', title: 'Storable'},
  [SampleFilterType.STRING]: {singular: 'string', plural: 'strings', title: 'String'},
  [SampleFilterType.WELL]: {singular: 'well', plural: 'wells', title: 'Well'},
};

// Callers should anticipate the possibility of receiving EMPTY_SAMPLE_DESCRIPTOR and formulate user-facing
// text accordingly.
export default function getSampleDescriptor(sampleFilter?: SampleFilter | null): SampleDescriptor {
  return sampleFilter ? sampleFilterTexts[sampleFilter.type] : EMPTY_SAMPLE_DESCRIPTOR;
}
